/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Document } from '../../core/models/Document';
import { DocumentType } from '../../core/models/DocumentType';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';

/**
 * Models an OpenAPI document.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Document
 */
export abstract class OasDocument extends Document implements ISecurityRequirementParent {
    public paths : OasPaths;

    public security : Array<SecurityRequirement>;

    /**
     * Creates an OAS Paths object.
     * @return {OasPaths}
     */
    public abstract createPaths() : OasPaths;

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public abstract createSecurityRequirement() : OasSecurityRequirement;

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#addSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} securityRequirement
     * @return {SecurityRequirement}
     */
    public addSecurityRequirement(securityRequirement : SecurityRequirement) : SecurityRequirement {
        if(this.security == null) {
            this.security = <any>([]);
        }
        /* add */(this.security.push(securityRequirement)>0);
        return securityRequirement;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#getSecurityRequirements()
     * @return {SecurityRequirement[]}
     */
    public getSecurityRequirements() : Array<SecurityRequirement> {
        return this.security;
    }

    /**
     * Returns true if the document is an OpenAPI/Swagger 2.0 document.
     * @return {boolean}
     */
    public is2xDocument() : boolean {
        return this.getDocumentType() === DocumentType.openapi2;
    }

    /**
     * Returns true if the document is an OpenAPI 3.x document.
     * @return {boolean}
     */
    public is3xDocument() : boolean {
        return this.getDocumentType() === DocumentType.openapi3;
    }

    constructor() {
        super();
        if(this.paths===undefined) this.paths = null;
        if(this.security===undefined) this.security = null;
    }
}
OasDocument["__class"] = "io.apicurio.datamodels.openapi.models.OasDocument";
OasDocument["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { OasSecurityRequirement } from './OasSecurityRequirement';


import { OasPaths } from './OasPaths';

